module.exports = __webpack_public_path__ + "logos/logo-amixr.2d0914.svg";